/** @file unzipBundle: a server export zip unpacked into bundle files keyed by bundle path. */
import { unzipSync } from 'fflate';

/**
 * Every file of the zip by path relative to its `manifest.json` (a zip that wraps the bundle in one folder is
 * unwrapped; directory entries are dropped). Throws when the zip holds no `manifest.json`.
 */
export function unzipBundle(bytes: Uint8Array): Record<string, Uint8Array> {
  const entries = unzipSync(bytes);
  const manifests = Object.keys(entries).filter((p) => p === 'manifest.json' || p.endsWith('/manifest.json'));
  const manifest = manifests.sort((a, b) => a.length - b.length)[0];
  if (manifest === undefined) throw new Error('unzipBundle: the zip has no manifest.json');
  const prefix = manifest.slice(0, manifest.length - 'manifest.json'.length);
  const files: Record<string, Uint8Array> = {};
  for (const [path, content] of Object.entries(entries)) {
    if (!path.startsWith(prefix) || path.endsWith('/')) continue;
    files[path.slice(prefix.length)] = content;
  }
  return files;
}
